import { useParams } from "react-router-dom"
import React, { useState, useEffect, Fragment } from 'react'
import { Box, Card, Checkbox, Container, FormControl, FormControlLabel, FormGroup, FormLabel, Grid, IconButton, TextField, Tooltip, Typography } from "@mui/material"
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material"
// import DownloadIcon from "@mui/icons-material/Download";
import api from "../../../../services/api";
import DateView from "../../../../utils/date";
import HeaderSession from "../../../../utils/headerSession";
import { makeStyles } from "@material-ui/core";
import NavLateral from "./navLateral";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";
import Email from "../../../../utils/email";
import InfoFieldGroup from "../../../../utils/InfoField/InfoFieldGroup"
import CreateObservacaoFarmacovigilancia from "./createObservacaoFarmacovigilancia"
import { useSelector } from "react-redux"
import ResponseFarmacovigilancia from "./responseFarmacovigilancia"
import AddAnexos from "../../../../pages/home/services/farmacovigilancia/addAnexos"
import { AnaliseNaranjoPdf } from "./documentosGerados/analiseNarranjoPdf"
import { FichaNotificacaoProdutosBaixaQualidadePdf } from "./documentosGerados/fichaNotificaoPdf"
import { FichaNotificacaoReacoesAdversas } from "./documentosGerados/fichaReaccoesPdf"
import ProcessoLoading from "../../../../load/processoLoading"
import { Download } from "@mui/icons-material"

const useStyles = makeStyles((theme) => ({
    grid1: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",

        [theme.breakpoints.up("md")]: {
            // width: '100%',
            height: "100%",
            position: "sticky",
            top: 70,
        },
    },
    grid2: {
        flexGrow: 1,
        marginLeft: 15,
        width: 500,
        zIndex: 1,
    },
}));

export default function GestFarmacovigilancia({ element: component, ...rest }) {
    const classes = useStyles();
    let { id } = useParams()
    const [notificacao, setNotificacao] = useState('')
    const user = useSelector(state => state.account.user);
    const [update, setUpdate] = useState(false)
    const handleChange = () => { };
    const [anchorEl, setAnchorEl] = useState(null);

    const getChecked = (key) => {
        const v = notificacao?.efeitosIndesejados?.evolucaoEfeitos?.[key];
        if (typeof v === 'boolean') return v;
        if (typeof v === 'string') return v.toLowerCase() === 'true' || v === '1';
        if (typeof v === 'number') return v === 1;
        return false;
    };

    // Estado do modal de apresentação
    const [openApresentacao, setOpenApresentacao] = useState(false);
    const [apresentacaoData, setApresentacaoData] = useState(null);

    const opcoesApresentacao = [
        { key: 'a', label: 'Comprimidos/cápsulas orais' },
        { key: 'b', label: 'Suspensão, xaropes' },
        { key: 'c', label: 'Injecção' },
        { key: 'd', label: 'Diluente' },
        { key: 'e', label: 'Pó para reconstituição da suspensão' },
        { key: 'f', label: 'Pó para reconstituição de injectáveis' },
        { key: 'g', label: 'Gotas oftálmicas' },
        { key: 'h', label: 'Gotas nasais' },
        { key: 'i', label: 'Gotas auriculares' },
        { key: 'j', label: 'Nebulizadores' },
        { key: 'k', label: 'Cremes, pomadas, pastas, linimentos' },
    ];

    const abrirModalApresentacao = (item) => {
        // Preferir novo payload: item.apresentacaoProducto
        let data = item?.apresentacaoProducto && typeof item.apresentacaoProducto === 'object'
            ? item.apresentacaoProducto
            : null;

        // Fallback: formato antigo com campos identificacaoProductoApresentacaoProductoA..K e ...Outros
        if (!data) {
            const d = {};
            ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'].forEach(L => {
                d[L.toLowerCase()] = item?.[`identificacaoProductoApresentacaoProducto${L}`] === true;
            });
            const outrosAntigo = item?.identificacaoProductoApresentacaoProductoOutros;
            if (Object.values(d).some(Boolean) || outrosAntigo) {
                d.outros = outrosAntigo || '';
                data = d;
            }
        }

        setApresentacaoData(data || {});
        setOpenApresentacao(true);
    };

    // Opções de defeitos (usadas para listas na visualização)
    const opcoesDefeitos = [
        { key: 'a', label: 'Separação' },
        { key: 'b', label: 'Solidificação' },
        { key: 'c', label: 'Esfarelamento' },
        { key: 'd', label: 'Moldura defeituasa' },
        { key: 'e', label: 'Mudança de Cheiro' },
        { key: 'f', label: 'Mudança de cor' },
        { key: 'g', label: 'Rotulagem defeituosa' },
        { key: 'h', label: 'Acondicionamento defeituoso' },
        { key: 'i', label: 'Rotulagem e prospecto deficiente' },
    ];

    // (Removidos helpers de lista baseados em <ul>; agora usamos checkboxes desabilitados)

    // Helpers para obter os dados brutos e facilitar a renderização de checkboxes
    const getApresentacaoDataRaw = (item) => {
        let data = item?.apresentacaoProducto && typeof item.apresentacaoProducto === 'object'
            ? item.apresentacaoProducto
            : null;
        if (!data) {
            const d = {};
            ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k'].forEach((key, idx) => {
                const L = String.fromCharCode(65 + idx);
                d[key] = item?.[`identificacaoProductoApresentacaoProducto${L}`] === true;
            });
            const outrosAntigo = item?.identificacaoProductoApresentacaoProductoOutros;
            if (Object.values(d).some(Boolean) || outrosAntigo) {
                d.outros = outrosAntigo || '';
                data = d;
            }
        }
        return data || {};
    };

    const getDefeitosDataRaw = (item) => {
        const data = item?.defeitos && typeof item.defeitos === 'object' ? item.defeitos : {};
        return data || {};
    };

    // Monta respostas para o card "Condições de armazenamento" (read-only)
    const getArmazenamentoRespostas = () => {
        const ca = notificacao?.conducoesArmazenamento || {};
        // Mapeamento: a..e -> perguntas Sim/Não; f -> detalhes/outros (e fallback se vier em outro campo)
        const pickResp = (k) => (ca?.[k]?.resposta || '').toString();
        // Escolhe o primeiro outrosDetalhes preenchido em a..f como fallback
        const outrosDetalhes = (
            ca?.f?.outrosDetalhes ||
            ca?.a?.outrosDetalhes ||
            ca?.b?.outrosDetalhes ||
            ca?.c?.outrosDetalhes ||
            ca?.d?.outrosDetalhes ||
            ca?.e?.outrosDetalhes ||
            ''
        );
        return {
            requerRefrigeracao: pickResp('a'),
            jaFoiUsado: pickResp('b'),
            foiDevolvido: pickResp('c'),
            defeitoDetectado: pickResp('d'),
            armazenadoCorretamente: pickResp('e'),
            conducoesArmazenamentoOutrosDetalhes: outrosDetalhes,
        };
    };

    // Helper para formatar datas de manifestação (evita problemas do componente <Date /> aqui)
    const formatarDataManifestacao = (valor, incluirHora = false) => {
        if (!valor) return '';
        const meses = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
        const d = new Date(valor);
        if (Number.isNaN(d.getTime())) return '';
        const dia = d.getDate();
        const mes = meses[d.getMonth()];
        const ano = d.getFullYear();
        if (incluirHora) {
            const hora = d.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
            return ` ${dia} de ${mes} as ${hora}h de ${ano}`;
        }
        return `dia ${dia} ${mes} ${ano}`;
    };

    useEffect(() => {
        api.get(`/farmaco-vigilancia/${id}`)
            .then(response => {
                // console.log(response)
                setNotificacao(response.data.farmacoVigilancia);
            }).catch(error => {
                // console.log(error)
                // if (error.response.status === 500) {
                //     setMessageError('Reclamação não encontrada')
                //     window.setTimeout(() => {
                //         navigate(-1)
                //     }, 1000);
                // }
            })
    }, [id, update])


    return (
        notificacao
            ?
            <Container>
                <HeaderSession title={'GESTÃO DE NOTIFICAÇÃO'} />

                <Grid container>
                    <Grid item className={classes.grid1}>
                        <NavLateral
                            observacoesFeitas={notificacao?.observacoes}
                            notificacao={notificacao}
                            setUpdate={setUpdate}
                        />
                    </Grid>

                    <Grid xs item className={classes.grid2} style={{ marginLeft: 15 }}>

                        {component &&

                            React.cloneElement(component, {
                                notificacao: notificacao,
                                setNotificacao: setNotificacao,
                            })
                        }


                        {/* ANALISE DE NARRANJO */}
                        {notificacao?.casualidadeRAM &&
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs
                                    title='Causalidade de RAM de acordo com o Algoritimo de Naranjo e Colab'
                                    actions={true}
                                    handleExportPDF={() => AnaliseNaranjoPdf(notificacao?.casualidadeRAM)}
                                />

                                <InfoFieldGroup
                                    // submit={submitEdit}
                                    // data={editDados}
                                    // handleChange={handleChange}
                                    // setIsEdit={setIsEdit}
                                    variant="subtitle2"
                                    isEdit={false}
                                    load={false}
                                    fields={
                                        [
                                            { label: '1. Existem estudos prévios sobre essa reacção?', value: notificacao?.casualidadeRAM?.pergunta1, key: 'pergunta1', onChange: (v) => 'setEditDados({ ...editDados, pergunta1: v.target.value })' },
                                            { label: '2. A reacção adversa ocorreu após administração do medicamento?', value: notificacao?.casualidadeRAM?.pergunta2, key: 'pergunta2', onChange: (v) => 'setEditDados({ ...editDados, pergunta2: v.target.value })' },
                                            { label: '3. O paciente melhora quando o medicamento é retirado ou quando se administra um antagonista específico?', value: notificacao?.casualidadeRAM?.pergunta3, key: 'pergunta3', onChange: (v) => 'setEditDados({ ...editDados, pergunta3: v.target.value })' },
                                            { label: '4. A reacção reaparece quando se readministra o medicamento?', value: notificacao?.casualidadeRAM?.pergunta4, key: 'pergunta4', onChange: (v) => 'setEditDados({ ...editDados, pergunta4: v.target.value })' },
                                            { label: '5. Excluindo o uso de medicamentos, existem outras causas capazes de determinar o surgimento da reacção?', value: notificacao?.casualidadeRAM?.pergunta5, key: 'pergunta5', onChange: (v) => 'setEditDados({ ...editDados, pergunta5: v.target.value })' },
                                            { label: '6. A reacção reaparece ao se administrar placebo?', value: notificacao?.casualidadeRAM?.pergunta6, key: 'pergunta6', onChange: (v) => 'setEditDados({ ...editDados, pergunta6: v.target.value })' },
                                            { label: '7. O medicamento foi detectado em sangue ou outros líquidos orgânicos em concentrações tóxicas?', value: notificacao?.casualidadeRAM?.pergunta7, key: 'pergunta7', onChange: (v) => 'setEditDados({ ...editDados, pergunta7: v.target.value })' },
                                            { label: '8. A reacção foi mais intensa quando se aumentou a dose ou menos intensa quando a dose foi reduzida?', value: notificacao?.casualidadeRAM?.pergunta8, key: 'pergunta8', onChange: (v) => 'setEditDados({ ...editDados, pergunta8: v.target.value })' },
                                            { label: '9. O paciente já apresentou alguma reacção semelhante ao mesmo medicamento ou outro similar?', value: notificacao?.casualidadeRAM?.pergunta9, key: 'pergunta9', onChange: (v) => 'setEditDados({ ...editDados, pergunta9: v.target.value })' },
                                            { label: '10. A reacção adversa foi confirmada por meio de alguma evidência objectiva?', value: notificacao?.casualidadeRAM?.pergunta10, key: 'pergunta10', onChange: (v) => 'setEditDados({ ...editDados, pergunta10: v.target.value })' },
                                            { label: 'Lenda / Tipo de Reacção', value: notificacao?.casualidadeRAM?.tipoReaccao, key: 'tipoReaccao', onChange: (v) => 'setEditDados({ ...editDados, tipoReaccao: v.target.value })' },
                                            { label: 'Lenda / Pontuação', value: notificacao?.casualidadeRAM?.pontuacao, key: 'pontuacao', onChange: (v) => 'setEditDados({ ...editDados, pontuacao: v.target.value })' },
                                        ]
                                    } />


                            </Card>
                        }

                        <Card style={{ padding: 20, marginBottom: 10 }}>
                            <DialogActions >
                                <Tooltip title="Baixar">
                                    <IconButton onClick={() =>
                                        notificacao?.tipo === 'Notificação de Suspeita de Producto com Baixa Qualidade'
                                            ? FichaNotificacaoProdutosBaixaQualidadePdf(notificacao)
                                            : FichaNotificacaoReacoesAdversas(notificacao)
                                    }>
                                        <Download />
                                    </IconButton>
                                </Tooltip>
                            </DialogActions>

                            <InfoFieldGroup
                                // submit={submitEdit}
                                // data={editDados}
                                // handleChange={handleChange}
                                // setIsEdit={setIsEdit}
                                isEdit={false}
                                load={false}
                                fields={
                                    [
                                        { label: 'Estado', value: notificacao?.status, editable: false, },
                                        { label: 'Número de notificação', value: notificacao?.numero, key: 'numero', onChange: (v) => 'setEditDados({ ...editDados, numero: v.target.value })' },
                                        { label: 'Data da notificação', value: <DateView date={notificacao?.createdAt} />, key: 'createdAt', onChange: (v) => 'setEditDados({ ...editDados, createdAt: v.target.value })' },
                                        { label: 'Data de entrada', value: <DateView date={notificacao?.dataNotificacao} />, key: 'dataNotificacao', onChange: (v) => 'setEditDados({ ...editDados, dataNotificacao: v.target.value })' },
                                        { label: 'Data de despacho', value: notificacao?.dataDespacho && <DateView date={notificacao?.dataDespacho} />, key: 'dataDespacho', onChange: (v) => 'setEditDados({ ...editDados, dataDespacho: v.target.value })' },
                                        { label: 'Tipo de notificação', value: notificacao?.tipo, key: 'tipo', onChange: (v) => 'setEditDados({ ...editDados, tipo: v.target.value })' },
                                        { label: 'Dados relevantes do Laboratório', value: notificacao?.dadosRelevantesLaboratorio, key: 'dadosRelevantesLaboratorio', onChange: (v) => 'setEditDados({ ...editDados, dadosRelevantesLaboratorio: v.target.value })' },
                                    ]
                                } />
                        </Card>


                        <Card style={{ padding: 20, marginBottom: 10, }}>
                            <HeaderGestorConfigs title='Entidade Sanitária' />
                            <InfoFieldGroup
                                // submit={submitEdit}
                                // data={editDados}
                                // handleChange={handleChange}
                                // setIsEdit={setIsEdit}
                                isEdit={false}
                                load={false}
                                fields={
                                    [
                                        { label: 'Unidade sanitária/Farmácia', value: notificacao?.unidadeSanitaria?.nome, key: 'nome', onChange: (v) => 'setEditDados({ ...editDados, nome: v.target.value })' },
                                        { label: 'Serviço', value: notificacao?.unidadeSanitaria?.servico, key: 'servico', onChange: (v) => 'setEditDados({ ...editDados, servico: v.target.value })' },
                                        { label: 'Província', value: notificacao?.unidadeSanitaria?.provincia, key: 'provincia', onChange: (v) => 'setEditDados({ ...editDados, provincia: v.target.value })' },
                                        { label: 'Município', value: notificacao?.unidadeSanitaria?.municipio, key: 'municipio', onChange: (v) => 'setEditDados({ ...editDados, municipio: v.target.value })' },
                                        { label: 'Bairro', value: notificacao?.unidadeSanitaria?.bairro, key: 'bairro', onChange: (v) => 'setEditDados({ ...editDados, bairro: v.target.value })' },
                                        { label: 'Rua', value: notificacao?.unidadeSanitaria?.rua, key: 'rua', onChange: (v) => 'setEditDados({ ...editDados, rua: v.target.value })' },
                                        { label: '', value: <Email email={notificacao?.unidadeSanitaria?.email} />, key: 'email', onChange: (v) => 'setEditDados({ ...editDados, email: v.target.value })' },
                                    ]
                                } />
                        </Card>


                        {notificacao?.tipo === 'Notificação de Suspeita de Producto com Baixa Qualidade' && (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Condições de armazenamento' />
                                {(() => {
                                    const Respostas = getArmazenamentoRespostas();
                                    return (
                                        <Grid container spacing={2} style={{ margin: '0 10px' }}>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O Produto  requer refrigeração?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="requerRefrigeracao" checked={Respostas.requerRefrigeracao === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="requerRefrigeracao" checked={Respostas.requerRefrigeracao === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O produto já foi usado na unidade sanitária?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="jaFoiUsado" checked={Respostas.jaFoiUsado === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="jaFoiUsado" checked={Respostas.jaFoiUsado === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O produto foi entregue e devolvido pelo cliente/paciente?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="foiDevolvido" checked={Respostas.foiDevolvido === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="foiDevolvido" checked={Respostas.foiDevolvido === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O defeito foi detectado pela unidade sanitária?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="defeitoDetectado" checked={Respostas.defeitoDetectado === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="defeitoDetectado" checked={Respostas.defeitoDetectado === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item xs={12} sm={6}>
                                                    <FormLabel>O Produto está armazenado de acordo com as Boas Práticas de Armazenamento?</FormLabel>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="armazenadoCorretamente" checked={Respostas.armazenadoCorretamente === 'Sim'} disabled />}
                                                        label="Sim"
                                                    />
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <FormControlLabel
                                                        sx={{ pointerEvents: 'none' }}
                                                        control={<Checkbox name="armazenadoCorretamente" checked={Respostas.armazenadoCorretamente === 'Não'} disabled />}
                                                        label="Não"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid display="flex" flexDirection="column" container spacing={1} marginRight={3} marginTop={4}>
                                                <FormLabel>Outros detalhes:</FormLabel>

                                                <TextField
                                                    // label=""
                                                    name="conducoesArmazenamentoOutrosDetalhes"
                                                    multiline
                                                    variant="filled"
                                                    // fullWidth
                                                    // size="small"
                                                    value={Respostas.conducoesArmazenamentoOutrosDetalhes || ''}
                                                    InputProps={{ readOnly: true }}
                                                    sx={{ mt: 1, pointerEvents: 'none' }}
                                                />
                                            </Grid>
                                        </Grid>
                                    );
                                })()}
                            </Card>
                        )}

                        {notificacao?.tipo === 'Notificação de Reações Adversas a Medicamentos e Producto Sanitários' && (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Paciente' />

                                <InfoFieldGroup
                                    // submit={submitEdit}
                                    // data={editDados}
                                    // handleChange={handleChange}
                                    // setIsEdit={setIsEdit}
                                    isEdit={false}
                                    load={false}
                                    fields={
                                        [
                                            { label: 'Nome', value: notificacao?.paciente?.nome, key: 'nome', onChange: (v) => 'setEditDados({ ...editDados, nome: v.target.value })' },
                                            { label: 'Telefone', value: notificacao?.paciente?.telefone, key: 'telefone', onChange: (v) => 'setEditDados({ ...editDados, telefone: v.target.value })' },
                                            { label: 'Email', value: notificacao?.paciente?.email, key: 'email', onChange: (v) => 'setEditDados({ ...editDados, email: v.target.value })' },
                                            { label: 'Idade', value: notificacao?.paciente?.idade, key: 'idade', onChange: (v) => 'setEditDados({ ...editDados, idade: v.target.value })' },
                                            { label: 'Sexo', value: notificacao?.paciente?.sexo === "M" ? "Masculino" : notificacao?.paciente?.sexo === "F" ? "Femenino" : '', key: 'sexo', onChange: (v) => 'setEditDados({ ...editDados, sexo: v.target.value })' },
                                            { label: 'Provincia', value: notificacao?.paciente?.provincia, key: 'provincia', onChange: (v) => 'setEditDados({ ...editDados, provincia: v.target.value })' },
                                            { label: 'Municipio', value: notificacao?.paciente?.municipio, key: 'municipio', onChange: (v) => 'setEditDados({ ...editDados, municipio: v.target.value })' },
                                            { label: 'Bairro', value: notificacao?.paciente?.bairro, key: 'bairro', onChange: (v) => 'setEditDados({ ...editDados, bairro: v.target.value })' },
                                            { label: 'Peso', value: notificacao?.paciente?.peso, key: 'peso', onChange: (v) => 'setEditDados({ ...editDados, peso: v.target.value })' },
                                            { label: 'Altura', value: notificacao?.paciente?.altura, key: 'altura', onChange: (v) => 'setEditDados({ ...editDados, altura: v.target.value })' },
                                            { label: 'Raça', value: notificacao?.paciente?.raca, key: 'raca', onChange: (v) => 'setEditDados({ ...editDados, raca: v.target.value })' },
                                            { label: '', value: <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.gestante} onChange={handleChange} name="medicosSP" />} label="Gestante" />, key: '', onChange: (v) => 'setEditDados({ ...editDados, fkl: v.target.value })' }
                                        ]
                                    } />


                                <Box marginTop={2}>
                                    <HeaderGestorConfigs title='Paciente / Antecedentes' />
                                    <InfoFieldGroup
                                        // submit={submitEdit}
                                        // data={editDados}
                                        // handleChange={handleChange}
                                        // setIsEdit={setIsEdit}
                                        isEdit={false}
                                        load={false}
                                        fields={
                                            [
                                                { label: '', value: <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.antecendentes?.medicosSP} onChange={handleChange} name="medicosSP" />} label="Médicos, Serológicos, Psiquiátrico" />, key: '', onChange: (v) => 'setEditDados({ ...editDados, nome: v.target.value })' },
                                                { label: '', value: <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.antecendentes?.cirurgicos} onChange={handleChange} name="cirurgicos" />} label="Cirúrgicos" />, key: '', onChange: (v) => 'setEditDados({ ...editDados, nome: v.target.value })' },
                                                { label: '', value: <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.antecendentes?.abusoDependencia} onChange={handleChange} name="abusoDependencia" />} label="De Abuso ou Dependência" />, key: '', onChange: (v) => 'setEditDados({ ...editDados, nome: v.target.value })' },
                                                { label: '', value: <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.paciente?.antecendentes?.alergiasConhecidas} onChange={handleChange} name="alergiasConhecidas" />} label="Alergias conhecidas" />, key: '', onChange: (v) => 'setEditDados({ ...editDados, nome: v.target.value })' },
                                            ]
                                        } />

                                </Box>

                            </Card>
                        )}

                        {notificacao?.tipo === 'Notificação de Suspeita de Producto com Baixa Qualidade' ? (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Identificação do produto' />
                                <TableContainer component={Paper} style={{ marginTop: 8 }}>
                                    <Table size="small" stickyHeader aria-label="tabela de identificação do produto">
                                        <TableHead>
                                            <TableRow>
                                                {/* <TableCell align="center">N.º</TableCell> */}
                                                <TableCell align="center"><Typography noWrap>Nome comercial / DCI</Typography> </TableCell>
                                                <TableCell align="center"><Typography noWrap>Número do lote</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Data de fabrico</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Data de expiração</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Data de recepção</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Fabricante</Typography></TableCell>
                                                <TableCell align="center"><Typography noWrap>Fornecedor</Typography></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(notificacao?.identificacaoProducto || []).map((item, index) => (
                                                <Fragment key={index}>
                                                    <TableRow hover>
                                                        {/* <TableCell align="center">{index + 1}</TableCell> */}
                                                        <TableCell align="center">{[item?.nomeCormecial, item?.nomeDCI].filter(Boolean).join(' / ')}</TableCell>
                                                        <TableCell align="center">{item?.numeroLote || ''}</TableCell>
                                                        <TableCell align="center">{item?.dataFabrico ? <DateView date={item?.dataFabrico} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.dataExpiracao ? <DateView date={item?.dataExpiracao} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.dataRecepcao ? <DateView date={item?.dataRecepcao} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.nomeFabricante || ''}</TableCell>
                                                        <TableCell align="center">{item?.nomeFornecedor || ''}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                        <TableCell colSpan={7} style={{ background: '#fafafa', padding: 12 }}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12} md={6}>
                                                                    <Typography variant="subtitle2" sx={{ color: '#85287E', fontWeight: 600 }}>Apresentação do produto</Typography>
                                                                    {(() => {
                                                                        const data = getApresentacaoDataRaw(item);
                                                                        const temAlgum = opcoesApresentacao.some(opt => Boolean(data?.[opt.key])) || Boolean(data?.outros);
                                                                        return temAlgum ? (
                                                                            <Grid container spacing={0} sx={{ mt: 0.2 }}>
                                                                                {opcoesApresentacao.map(opt => (
                                                                                    <Grid item xs={12} key={opt.key}>
                                                                                        <FormControlLabel
                                                                                            onClick={(e) => e.preventDefault()}
                                                                                            sx={{ pointerEvents: 'none', cursor: 'default' }}
                                                                                            control={
                                                                                                <Checkbox
                                                                                                    checked={Boolean(data?.[opt.key])}
                                                                                                    tabIndex={-1}
                                                                                                    disableRipple
                                                                                                    onClick={(e) => e.preventDefault()}
                                                                                                    sx={{ pointerEvents: 'none', cursor: 'default' }}
                                                                                                    inputProps={{ tabIndex: -1, 'aria-disabled': true }}
                                                                                                />
                                                                                            }
                                                                                            label={opt.label}
                                                                                        />
                                                                                    </Grid>
                                                                                ))}
                                                                                {data?.outros ? (
                                                                                    <Grid item xs={12}>
                                                                                        <FormLabel component="legend">Outros</FormLabel>
                                                                                        <TextField value={data?.outros || ''} fullWidth InputProps={{ readOnly: true }} size="small" sx={{ mt: 0.5 }} />
                                                                                    </Grid>
                                                                                ) : null}
                                                                            </Grid>
                                                                        ) : (
                                                                            <Typography variant="body2" color="text.secondary">Sem informação</Typography>
                                                                        );
                                                                    })()}
                                                                </Grid>
                                                                <Grid item xs={12} md={6}>
                                                                    <Typography variant="subtitle2" sx={{ color: '#85287E', fontWeight: 600 }}>Defeitos</Typography>
                                                                    {(() => {
                                                                        const data = getDefeitosDataRaw(item);
                                                                        const temAlgum = opcoesDefeitos.some(opt => Boolean(data?.[opt.key])) || Boolean(data?.outros);
                                                                        return temAlgum ? (
                                                                            <Grid container spacing={0} sx={{ mt: 0.2 }}>
                                                                                {opcoesDefeitos.map(opt => (
                                                                                    <Grid item xs={12} key={opt.key}>
                                                                                        <FormControlLabel
                                                                                            onClick={(e) => e.preventDefault()}
                                                                                            control={
                                                                                                <Checkbox
                                                                                                    checked={Boolean(data?.[opt.key])}
                                                                                                    tabIndex={-1}
                                                                                                    disableRipple
                                                                                                    onClick={(e) => e.preventDefault()}
                                                                                                />
                                                                                            }
                                                                                            label={opt.label}
                                                                                        />
                                                                                    </Grid>
                                                                                ))}
                                                                                {data?.outros ? (
                                                                                    <Grid item xs={12}>
                                                                                        <FormLabel component="legend">Outros</FormLabel>
                                                                                        <TextField value={data?.outros || ''} fullWidth InputProps={{ readOnly: true }} size="small" sx={{ mt: 0.5 }} />
                                                                                    </Grid>
                                                                                ) : null}
                                                                            </Grid>
                                                                        ) : (
                                                                            <Typography variant="body2" color="text.secondary">Sem informação</Typography>
                                                                        );
                                                                    })()}
                                                                </Grid>
                                                            </Grid>
                                                        </TableCell>
                                                    </TableRow>
                                                </Fragment>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Card>
                        ) : (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Medicamentos' />
                                <div >
                                    <TableContainer component={Paper} style={{ marginTop: 8 }}>
                                        <Table size="small" stickyHeader aria-label="tabela de medicamentos">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell align="center"><Typography noWrap>N.º</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Nome comercial / DCI</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Apresentação</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Dose diária</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Via e local de administração</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Motivo do tratamento</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Número do lote</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Data de caducidade</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Local de compra</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Início do tratamento</Typography></TableCell>
                                                    <TableCell align="center"><Typography noWrap>Término do tratamento</Typography></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {(notificacao?.identificacaoProducto || []).map((item, index) => (
                                                    <TableRow key={index} hover>
                                                        <TableCell align="center">{index + 1}</TableCell>
                                                        <TableCell align="center">{[item?.nomeCormecial, item?.nomeDCI].filter(Boolean).join(' / ')}</TableCell>
                                                        <TableCell align="center">
                                                            <Button variant="text" onClick={() => abrirModalApresentacao(item)}>
                                                                Ver apresentação
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell align="center">{item?.doseDiaria || ''}</TableCell>
                                                        <TableCell align="center">{item?.viaLocalAdmin || ''}</TableCell>
                                                        <TableCell align="center">{item?.motivoTratamento || ''}</TableCell>
                                                        <TableCell align="center">{item?.numeroLote || ''}</TableCell>
                                                        <TableCell align="center">{item?.dataExpiracao ? <DateView date={item?.dataExpiracao} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.localCompra || ''}</TableCell>
                                                        <TableCell align="center">{item?.InicioDataToma ? <DateView date={item?.InicioDataToma} /> : ''}</TableCell>
                                                        <TableCell align="center">{item?.terminoDataToma ? <DateView date={item?.terminoDataToma} /> : ''}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Card style={{ padding: 20, marginTop: 10, }}>
                                        <HeaderGestorConfigs title='Outras Indicações' />
                                        <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.automedicacao} onChange={handleChange} name="automedicacao" />} label="Automedicação" />
                                        <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.farmacodependencia} onChange={handleChange} name="farmacodependencia" />} label="Farmacodependência" />
                                        <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.erroTerapeutico} onChange={handleChange} name="erroTerapeutico" />} label="Erro Terapêutico" />
                                        <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.campanhaVacinacao} onChange={handleChange} name="campanhaVacinacao" />} label="Campanha Vacinação" />
                                    </Card>
                                </div>
                            </Card>
                        )}

                        <Dialog open={openApresentacao} onClose={() => setOpenApresentacao(false)} maxWidth="md" fullWidth>
                            <DialogTitle>Apresentação do produto</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    {opcoesApresentacao.map(opt => (
                                        <Grid item xs={12} sm={6} md={4} key={opt.key}>
                                            <div
                                                style={{
                                                    background: apresentacaoData?.[opt.key] ? '#85287E' : '#f6f2fc',
                                                    borderRadius: 8,
                                                    padding: 12,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    transition: 'background 0.2s',
                                                    color: apresentacaoData?.[opt.key] ? '#fff' : '#85287E',
                                                }}
                                            >
                                                <FormControlLabel
                                                    onClick={(e) => e.preventDefault()}
                                                    sx={{ pointerEvents: 'none', cursor: 'default' }}
                                                    control={
                                                        <Checkbox
                                                            checked={Boolean(apresentacaoData?.[opt.key])}
                                                            tabIndex={-1}
                                                            disableRipple
                                                            onClick={(e) => e.preventDefault()}
                                                            sx={{
                                                                pointerEvents: 'none',
                                                                cursor: 'default',
                                                                color: apresentacaoData?.[opt.key] ? '#fff' : '#85287E',
                                                                '&.Mui-checked': { color: apresentacaoData?.[opt.key] ? '#fff' : '#85287E' },
                                                            }}
                                                            inputProps={{ tabIndex: -1, 'aria-disabled': true }}
                                                        />
                                                    }
                                                    label={<span style={{ fontWeight: 500, color: apresentacaoData?.[opt.key] ? '#fff' : '#85287E' }}>{opt.label}</span>}
                                                />
                                            </div>
                                        </Grid>
                                    ))}
                                </Grid>
                                {apresentacaoData?.outros ? (
                                    <Box mt={3}>
                                        <FormLabel component="legend" style={{ pointerEvents: 'none', color: '#85287E', fontWeight: 600 }}>Outros</FormLabel>
                                        <TextField value={apresentacaoData?.outros || ''} fullWidth InputProps={{ readOnly: true }} style={{ marginTop: 8 }} />
                                    </Box>
                                ) : null}
                            </DialogContent>
                            <DialogActions>
                                <Button color="secondary" onClick={() => setOpenApresentacao(false)}>Fechar</Button>
                            </DialogActions>
                        </Dialog>

                        {notificacao?.tipo === 'Notificação de Reações Adversas a Medicamentos e Producto Sanitários' && (
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Efeitos Indesejáveis' />

                                <FormControl component="fieldset">

                                    <FormGroup>
                                        <FormLabel marginTop={2} component="legend">Breve Descição de Efeito Indesejavel</FormLabel>
                                        <Box marginTop={2}>
                                            <TextField
                                                marginTop={2}
                                                // label="Breve descrição"
                                                variant="filled"
                                                value={notificacao?.efeitosIndesejados?.descricao ?? ''}
                                                multiline
                                                rows={4}
                                                fullWidth
                                                InputProps={{ readOnly: true }}
                                                sx={{ pointerEvents: 'none' }}
                                            />
                                        </Box>
                                        {(notificacao?.efeitosIndesejados?.inicioManifestacao || notificacao?.efeitosIndesejados?.fimManifestacao) ? (
                                            <Typography variant="body1" lineHeight={1.5} marginTop={4}>
                                                {`Prazo de manifestação: ${formatarDataManifestacao(notificacao?.efeitosIndesejados?.inicioManifestacao, true)}${(notificacao?.efeitosIndesejados?.inicioManifestacao && notificacao?.efeitosIndesejados?.fimManifestacao) ? ' à ' : ''}${formatarDataManifestacao(notificacao?.efeitosIndesejados?.fimManifestacao, false)}`}
                                            </Typography>
                                        ) : null}
                                    </FormGroup>

                                    <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px', gap: '2rem' }}>
                                        <FormGroup>
                                            <FormLabel component="legend">Evolução dos Efeitos indesejaveis</FormLabel>
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.riscoVida} onChange={handleChange} name="riscoVida" />} label="Risco de vida" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.motivouHospitalizacao} onChange={handleChange} name="motivouHospitalizacao" />} label="Motivou hospitalização" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.prolongouHospitalizacao} onChange={handleChange} name="prolongouHospitalizacao" />} label="Prolongou hospitalização" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.malformacaoCongenita} onChange={handleChange} name="malformacaoCongenita" />} label="Malformação Congênita" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.naoRecuperouAind} onChange={handleChange} name="naoRecuperouAind" />} label="Não recuperou ainda" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.recuperouSemSequelas} onChange={handleChange} name="recuperouSemSequelas" />} label="Recuperou sem sequelas" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.recuperouComSequelas} onChange={handleChange} name="recuperouComSequelas" />} label="Recuperou com sequelas" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.desconhecido} onChange={handleChange} name="desconhecido" />} label="Desconhecido" />
                                            <FormControlLabel sx={{ pointerEvents: 'none' }} control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.morte} onChange={handleChange} name="morte" />} label="Morte" />
                                            <FormControlLabel control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.suspendeuMedicamento} onChange={handleChange} name="suspendeuMedicamento" />} label="Suspendeu o Medicamento" />
                                            <FormControlLabel control={<Checkbox checked={notificacao?.efeitosIndesejados?.evolucaoEfeitos?.diminuiuDoseMedicamento} onChange={handleChange} name="diminuiuDoseMedicamento" />} label="Diminuiu a dose do Medicamento" />
                                            <Typography variant="body1" lineHeight={1.5}> Efeito desapareceu após suspensão?: {notificacao?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIDDASDM}</Typography>
                                            <Typography variant="body1" lineHeight={1.5}> Efeito reapareceu após reintrodução?: {notificacao?.efeitosIndesejados?.evolucaoEfeitos?.efeitoIRARDM}</Typography>
                                        </FormGroup>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '8px' }}>

                                            <FormGroup>
                                                <FormLabel marginTop={2} component="legend">Tratamento Corrector</FormLabel>
                                                <Box marginTop={2}>
                                                    <TextField
                                                        marginTop={2}
                                                        // label="Breve descrição"
                                                        variant="filled"
                                                        value={notificacao?.efeitosIndesejados?.descricao ?? ''}
                                                        multiline
                                                        rows={4}
                                                        fullWidth
                                                        InputProps={{ readOnly: true }}
                                                        sx={{ pointerEvents: 'none' }}
                                                    />
                                                </Box>
                                            </FormGroup>
                                        </div>
                                    </div>
                                </FormControl>
                            </Card>
                        )}


                        <Card style={{ padding: 20, marginBottom: 10, }}>
                            <HeaderGestorConfigs title='Notificador' />
                            <InfoFieldGroup
                                // submit={submitEdit}
                                // data={editDados}
                                // handleChange={handleChange}
                                // setIsEdit={setIsEdit}
                                isEdit={false}
                                load={false}
                                fields={
                                    [
                                        { label: 'Nome', value: notificacao?.notificador?.nome, key: 'nome', onChange: (v) => 'setEditDados({ ...editDados, nome: v.target.value })' },
                                        { label: 'Categoria Profissional', value: notificacao?.notificador?.categoriaProfissional, key: 'categoriaProfissional', onChange: (v) => 'setEditDados({ ...editDados, categoriaProfissional: v.target.value })' },
                                        { label: 'Telefone', value: notificacao?.notificador?.tel, key: 'tel', onChange: (v) => 'setEditDados({ ...editDados, tel: v.target.value })' },
                                        { label: 'Email', value: notificacao?.notificador?.email, key: 'email', onChange: (v) => 'setEditDados({ ...editDados, email: v.target.value })' },

                                    ]
                                } />
                        </Card>

                        {(notificacao?.anexos && notificacao?.anexos.length > 0) &&
                            <Card style={{ padding: 20, marginBottom: 10, }}>
                                <HeaderGestorConfigs title='Imagens anexadas' />
                                <AddAnexos addanexos={false} formData={notificacao || []} />
                            </Card>
                        }



                        {/* CRIAR OBSERVACOES NO PROCESSO */}
                        <CreateObservacaoFarmacovigilancia
                            farmacoVigilanciaId={notificacao?._id}
                            userId={user._id}
                            setUpdate={setUpdate}
                        />

                        {/* ENVIAR UMA RESPOSTA SOBRE A NOTIFICACAO AO UTENTE */}
                        <ResponseFarmacovigilancia
                            farmacovigilancia={notificacao}
                            userId={user._id}
                            setUpdate={setUpdate}
                        />
                    </Grid>
                </Grid>



            </Container>
            :
            <ProcessoLoading />
    )
}